import { range } from 'ramda';

import { generateYearsSelectOptions } from 'CorePackage/MainModule/common/generateYearsSelectOptions';
import { IYearSelectOption } from 'CorePackage/MainModule/interfaces/IYearSelectOption';

import { currentYear } from './currentYear';

const yearsArrayWithNext = range(2015, Number(currentYear) + 2);

export const yearOptionsWithNext: IYearSelectOption[] = generateYearsSelectOptions(yearsArrayWithNext).reverse();
